import { render, staticRenderFns } from "./AppHelpMessage.vue?vue&type=template&id=02f6a36d"
import script from "./AppHelpMessage.vue?vue&type=script&lang=js"
export * from "./AppHelpMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports